import { useDispatch, useSelector } from "react-redux";

import { ThemeProvider } from "@mui/material/styles";
import { CssBaseline, StyledEngineProvider } from "@mui/material";
// routing
import Routes from "routes";

// defaultTheme
import themes from "themes";

// project imports
import NavigationScroll from "layout/NavigationScroll";

import { SnackBarProvider } from "context/snackbarContext";
import { TextFileValuesProvider } from "context/textFileValueContext";
import { CommonContextProvider } from "context/commonContext";
//Bootstrap and jQuery libraries
import "bootstrap/dist/css/bootstrap.min.css";
import "jquery/dist/jquery.min.js";

//Datatable Modules
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";

import "datatables.net-buttons/js/buttons.print.js";
import "datatables.net-buttons/js/buttons.html5.js";
import { useEffect } from "react";
import { fetchData } from "store/apis";
// import privilagesContext from "utils/Privileges";
// import { useState } from "react";
import { getPrivileges } from "reduxs/Thunks/Privileges";
import LoaderDrop from "utils/LoaderDrop";

const App = () => {
  const customization = useSelector((state) => state.customization);
  const {loading,privileges} = useSelector((state) => state.privilageSlice);
  const dispatch = useDispatch();
  // const [privileges, setPrivileges] = useState([]);
  // const [userType, setUserType] = useState([]);
  useEffect(() => {
    dispatch(fetchData());
    dispatch(getPrivileges());
  }, [dispatch]);
  if(loading){
return <LoaderDrop start={loading} />
  }
  return (
        // <privilagesContext.Provider value={{setPrivileges,privileges,userType, setUserType}}>
    <SnackBarProvider>
                
      
      <TextFileValuesProvider>
        <CommonContextProvider>
          <StyledEngineProvider injectFirst>
            <ThemeProvider theme={themes(customization)}>

              <CssBaseline />
              <NavigationScroll>
                <Routes />
              </NavigationScroll>
            </ThemeProvider>
          </StyledEngineProvider>
        </CommonContextProvider>
      </TextFileValuesProvider>
    </SnackBarProvider>
    // </privilagesContext.Provider>
  );
};

export default App;
